import { render } from "./AbtestMessageAddPage.vue?vue&type=template&id=ca44f724"
import script from "./AbtestMessageAddPage.vue?vue&type=script&lang=js"
export * from "./AbtestMessageAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__